import {sendAgentEvent} from './eventClient';

let activeExperience = null;

/**
 * Track an interactive UI experience opened for an agent command.
 * @param {object} envelope command correlation
 * @param {Function|null} close experience close callback
 * @return {void}
 */
export function trackActiveAgentExperience(envelope, close) {
	activeExperience = {
		request_id: envelope.request_id,
		command_id: envelope.command_id,
		session_id: envelope.session_id,
		workflow_instance_id: envelope.workflow_instance_id,
		workflow_revision: envelope.workflow_revision,
		idempotency_key: envelope.idempotency_key,
		close: typeof close === 'function' ? close : null,
	};
}

/**
 * Dismiss the experience owned by the active agent workflow.
 * @return {void}
 */
export function dismissActiveAgentExperience() {
	const experience = activeExperience;
	activeExperience = null;
	experience?.close?.();
}

/**
 * Report an interactive experience outcome to the active workflow.
 * @param {'experience.completed'|'experience.cancelled'|'experience.failed'} eventType lifecycle event
 * @param {string|null} errorCode Canvas error identifier
 * @return {Promise<object|null>} agent response
 */
export async function reportActiveAgentExperienceLifecycle(
	eventType,
	errorCode = null,
) {
	if (![
		'experience.completed',
		'experience.cancelled',
		'experience.failed',
	].includes(eventType)) {
		return null;
	}
	const envelope = activeExperience;
	if (!envelope) return null;
	activeExperience = null;
	const response = await sendAgentEvent({
		request_id: envelope.request_id,
		command_id: envelope.command_id,
		session_id: envelope.session_id,
		event_type: eventType,
		result: {},
		error_code: errorCode,
		workflow_instance_id: envelope.workflow_instance_id,
		workflow_revision: envelope.workflow_revision,
		idempotency_key: envelope.idempotency_key,
	});
	if (response?.message) {
		window.dispatchEvent(new CustomEvent('canvas-agent:reply', {
			detail: {response, sessionId: envelope.session_id},
		}));
	}
	return response;
}
